<template>
    <div class="page contain wider">
        <div class="section info title-only mb-10px">
            <div class="left">
                <h1 class="main-title">Overview</h1>
            </div>
            <div class="right buttons">
                <div class="button green px-8px" @click="showImportPortfolioModal = true"><span class="material-icons valign-middle text-23px">vertical_align_bottom</span></div>
                <div class="button green px-8px" @click="showAddPortfolioModal = true"><span class="material-icons valign-middle text-23px">add</span></div>
            </div>
        </div>

        <div class="table w-full">
            <thead class="thead">
                <tr class="tr">
                    <th class="th" colspan="100%">Portfolios</th>
                </tr>
            </thead>
            <tbody class="tbody">
                <tr class="tr" v-if="portfolios.length == 0"><td class="td" colspan="100%">No items found</td></tr>
                <!-- portfolios -->
                <PortfolioListRow v-for="(portfolio, i) in portfolios" :key="i" :portfolio="portfolio" @deleted="getPortfoliosFromStorage"/>
                <!-- combined portfolio -->
                <router-link v-if="portfolios.length > 1" to="/portfolio/full" class="tr clickable"><td class="td" colspan="3">Full portfolio</td></router-link>
            </tbody>
        </div>

        <AddPortfolioModal :showModal.sync="showAddPortfolioModal" @portfolioAdded="getPortfoliosFromStorage"/>
        <ImportPortfolioModal :showModal.sync="showImportPortfolioModal" @portfoliosImported="getPortfoliosFromStorage"/>
    </div>
</template>

<script>
import AddPortfolioModal from '@/components/portfolio/AddPortfolioModal.vue'
import ImportPortfolioModal from '@/components/portfolio/ImportPortfolioModal.vue'
import PortfolioListRow from '@/components/portfolio/PortfolioListRow.vue'

export default {
    components: { AddPortfolioModal, ImportPortfolioModal, PortfolioListRow },
    data(){
        return{
            showAddPortfolioModal: false,
            showImportPortfolioModal: false,
            portfolios: [],
        }
    },
    created(){
        this.getPortfoliosFromStorage()
    },
    methods:{
        getPortfoliosFromStorage(){
            this.portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')
        }
    }
}
</script>